import { useState } from 'react'
import faqContent from '@content/faq.yaml'
import type { FaqContent } from '@/types/content'

const content = faqContent as unknown as FaqContent

export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  return (
    <section id="faq" className="ss" aria-labelledby="faq-heading">
      <div className="ey reveal">{content.eyebrow}</div>
      <h2 id="faq-heading" className="sh2 reveal d2">{content.headline}</h2>
      <div className="faq-list reveal d2" role="list">
        {content.items.map((item, i) => (
          <div key={i} className={`faq-item${openIndex === i ? ' open' : ''}`} role="listitem">
            <button
              className="faq-q"
              onClick={() => setOpenIndex(openIndex === i ? null : i)}
              aria-expanded={openIndex === i}
              aria-controls={`faq-answer-${i}`}
            >
              {item.q} <span className="faq-chev" aria-hidden="true">+</span>
            </button>
            <div id={`faq-answer-${i}`} className="faq-a" role="region" aria-hidden={openIndex !== i}>
              {item.a}
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
